 
(function () {
  'use strict';

  class QuickViewDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-quick-view-dialog]');
      this.body = this.querySelector('[data-quick-view-body]');
      this.errorTemplate = this.querySelector('template[data-quick-view-error]');
      this.viewName = this.dataset.viewName || 'quick-view';
      this.sectionKey = this.dataset.sectionKey || 'quick-view';
      this.resolvedSectionId = null;
      this.opener = null;
      this.controller = null;
      this._suppressFocusRestore = false;

      this._onTriggerClick = this._onTriggerClick || this.handleTriggerClick.bind(this);
      document.addEventListener('click', this._onTriggerClick);

      
      this._onCartRefresh = this._onCartRefresh || this.handleCartRefresh.bind(this);
      document.addEventListener('cart:refresh', this._onCartRefresh);

      if (this.dialog) {
        this._onHidden = this._onHidden || this.handleHidden.bind(this);
        this.dialog.addEventListener('hidden.bs.offcanvas', this._onHidden);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onTriggerClick);
      document.removeEventListener('cart:refresh', this._onCartRefresh);
      if (this.dialog) this.dialog.removeEventListener('hidden.bs.offcanvas', this._onHidden);
      if (this.controller) this.controller.abort();
      this.clearTriggerLoading();
 
      if (this.dialog && window.bootstrap) {
        var instance = bootstrap.Offcanvas.getInstance(this.dialog);
        if (instance) instance.dispose();
      }
      document.querySelectorAll('.offcanvas-backdrop').forEach(function (backdrop) {
        if (!document.querySelector('.offcanvas.show')) backdrop.remove();
      });
      if (!document.querySelector('.offcanvas.show')) {
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('padding-right');
      }
    }

    get isOpen() {
      return !!this.dialog && this.dialog.classList.contains('show');
    }

    getOffcanvas() {
      if (!this.dialog || !window.bootstrap) return null;
      return bootstrap.Offcanvas.getOrCreateInstance(this.dialog);
    }

    handleTriggerClick(event) {
      var trigger = event.target.closest && event.target.closest('[data-quick-view]');
      if (!trigger) return;
      var url = trigger.getAttribute('data-product-url');
      if (!url) return;
      event.preventDefault();
      if (trigger === this._loadingTrigger) return;
      this.opener = trigger; 
      var hostSwiperEl = trigger.closest && trigger.closest('.swiper');
      this._hostSwiper = (hostSwiperEl && hostSwiperEl.swiper) || null;
      this._hostIndex = this._hostSwiper ? this._hostSwiper.activeIndex : null;
      this.open(url, trigger);
    }

    setTriggerLoading(trigger) {
      this.clearTriggerLoading();
      this._loadingTrigger = trigger;
      trigger.classList.add('is-loading');
      trigger.setAttribute('aria-busy', 'true');
    }

    clearTriggerLoading() {
      if (!this._loadingTrigger) return;
      this._loadingTrigger.classList.remove('is-loading');
      this._loadingTrigger.removeAttribute('aria-busy');
      this._loadingTrigger = null;
    }

    handleCartRefresh() {
      if (!this.isOpen) return;
      this._suppressFocusRestore = true;
      var offcanvas = this.getOffcanvas();
      if (offcanvas) offcanvas.hide();
    }

    handleHidden() {
      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }
      this.body.innerHTML = '';
      if (!this._suppressFocusRestore && this.opener && this.opener.focus) { 
        var swiperEl = this.opener.closest && this.opener.closest('.swiper');
        var sw = swiperEl && swiperEl.swiper;
        if (sw && sw.params && sw.params.a11y) sw.params.a11y.scrollOnFocus = false;
        this.opener.focus({ preventScroll: true });
        if (swiperEl) {
          swiperEl.scrollLeft = 0;
          swiperEl.scrollTop = 0;
        }
      }
      this._suppressFocusRestore = false;
      this.opener = null;

      var sw = this._hostSwiper;
      var idx = this._hostIndex;
      this._hostSwiper = null;
      this._hostIndex = null;
      if (sw && typeof idx === 'number') {
        var restoreHost = function () {
          if (sw.destroyed) return;
          if (sw.activeIndex !== idx) sw.slideTo(idx, 0);
          if (sw.el) {
            sw.el.scrollLeft = 0;
            sw.el.scrollTop = 0;
          }
        };
        restoreHost(); 
        requestAnimationFrame(function () {
          restoreHost();
          requestAnimationFrame(restoreHost);
        });
      }
    }

    appendParams(url, query) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + query;
    }

    open(url, trigger) {
      if (!this.dialog || !this.body) return;

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      var signal = this.controller.signal;
 
      if (trigger) this.setTriggerLoading(trigger);

      var viewParam = 'view=' + this.viewName;
      var sectionId = this.resolvedSectionId || this.sectionKey;
      var sectionUrl = this.appendParams(url, viewParam + '&section_id=' + sectionId);
      var pageUrl = this.appendParams(url, viewParam);
      var self = this;

      fetch(sectionUrl, { signal: signal })
        .then(function (response) {
          if (response.ok) return response.text(); 
          return fetch(pageUrl, { signal: signal }).then(function (pageResponse) {
            if (!pageResponse.ok) throw new Error('HTTP ' + pageResponse.status);
            return pageResponse.text();
          });
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-quick-view-content]');
          if (!content) throw new Error('Quick view markup not found');
          var section = content.closest('.shopify-section') || content;
         
          var match = section.id && section.id.match(/^shopify-section-(.+)$/);
          if (match) self.resolvedSectionId = match[1];
          self.clearTriggerLoading();
          self.inject(section);
          self.show();
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          self.clearTriggerLoading();
          self.setState(self.errorTemplate);
          self.show();
        });
    }

    show() {
      var offcanvas = this.getOffcanvas();
      if (offcanvas) offcanvas.show();
    }

    inject(sectionNode) {
      this.body.innerHTML = '';
     
      this.body.appendChild(document.importNode(sectionNode, true));
      this.activateScripts();
       
      document.dispatchEvent(new CustomEvent('theme:media:injected'));
    }
 
    activateScripts() {
      var loaded = {};
      var body = this.body;
      document.querySelectorAll('script[src]').forEach(function (script) {
        if (!body.contains(script)) loaded[script.src] = true;
      });
      body.querySelectorAll('script[src]').forEach(function (inert) {
        if (loaded[inert.src]) {
          inert.remove();
          return;
        }
        loaded[inert.src] = true;
        var script = document.createElement('script');
        script.src = inert.getAttribute('src');
        script.defer = true;
        inert.replaceWith(script);
      });
    }

    setState(template) {
      this.body.innerHTML = '';
      if (template) this.body.appendChild(template.content.cloneNode(true));
    }
  }

  if (!customElements.get('quick-view-drawer')) {
    customElements.define('quick-view-drawer', QuickViewDrawer);
  }
 
  class QuickViewMedia extends HTMLElement {
    connectedCallback() {
       
      this._onPlayCapture = this._onPlayCapture || this.handlePlayCapture.bind(this);
      this.addEventListener('play', this._onPlayCapture, true);

      
      this._onKeydown = this._onKeydown || this.handleKeydown.bind(this);
      this.addEventListener('keydown', this._onKeydown);
      this._onFocusIn = this._onFocusIn || this.handleFocusIn.bind(this);
      this.addEventListener('focusin', this._onFocusIn);

      this.ensureVideoFocusable();

      if (this.dataset.qvSwiperInit === 'true') return;
      var self = this;
      this._waitForSwiper(function () {
        self.initSlider();
      });
    }

    disconnectedCallback() {
      this.removeEventListener('play', this._onPlayCapture, true);
      this.removeEventListener('keydown', this._onKeydown);
      this.removeEventListener('focusin', this._onFocusIn);
      this.pauseAllExcept(null);
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
      delete this.dataset.qvSwiperInit;
    }

    handlePlayCapture(event) {
      var media = event.target;
      if (!media || media.tagName !== 'VIDEO') return;
      this.pauseAllExcept(media);
    }

    handleKeydown(event) {
      if (!this.swiperInstance) return;
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
     
      if (
        event.target.closest &&
        event.target.closest('input, textarea, select, video, iframe, model-viewer')
      ) {
        return;
      }
      event.preventDefault();
      if (event.key === 'ArrowRight') {
        this.swiperInstance.slideNext();
      } else {
        this.swiperInstance.slidePrev();
      }
    }

    handleFocusIn(event) {
      if (!this.swiperInstance) return;
      /* ModelViewerUI.play() focuses the model-viewer programmatically —
         that focus must not navigate the slider. */
      if (event.target.tagName === 'MODEL-VIEWER') return;
      var slide = event.target.closest ? event.target.closest('.swiper-slide') : null;
      if (!slide) return;
      /* Focusing an off-screen slide makes the browser scroll the
         overflow-hidden swiper container, which stacks on top of the
         slideTo() translate and lands the view one slide too far. */
      var swiperEl = slide.closest('.swiper');
      if (swiperEl) {
        swiperEl.scrollLeft = 0;
        swiperEl.scrollTop = 0;
      }
      var index = Array.prototype.indexOf.call(this.swiperInstance.slides, slide);
      if (index !== -1 && index !== this.swiperInstance.activeIndex) {
        this.swiperInstance.slideTo(index);
      }
    }

    /* Shopify's video_tag can't emit tabindex, and <video controls> is not
       reliably in the sequential tab order without one — stamp it so keyboard
       users can Tab to inline (autoplay) videos. Deferred videos get theirs
       in DeferredMedia.loadContent when cloned out of <template>. */
    ensureVideoFocusable() {
      this.querySelectorAll('video').forEach(function (video) {
        if (!video.hasAttribute('tabindex')) video.setAttribute('tabindex', '0');
      });
    }

    pauseAllExcept(exceptEl) {
      this.querySelectorAll('video').forEach(function (video) {
        if (exceptEl && (video === exceptEl || exceptEl.contains(video))) return;
        video.pause();
      });
      this.querySelectorAll('iframe').forEach(function (iframe) {
        if (exceptEl && (iframe === exceptEl || exceptEl.contains(iframe))) return;
        if (!iframe.contentWindow || !iframe.src) return;
        if (iframe.src.indexOf('youtube.com') !== -1) {
          iframe.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            '*'
          );
        } else if (iframe.src.indexOf('vimeo.com') !== -1) {
          iframe.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      });
      this.querySelectorAll('deferred-media[loaded="true"]').forEach(function (deferred) {
        if (exceptEl && deferred.contains(exceptEl)) return;
        if (typeof deferred.pauseModel === 'function') deferred.pauseModel();
      });
    }

    bindIframeHandshakes() {
      
      this.querySelectorAll('iframe').forEach(function (iframe) {
        if (!iframe.contentWindow || !iframe.src) return;
        if (iframe.src.indexOf('youtube.com') !== -1) {
          iframe.contentWindow.postMessage('{"event":"listening"}', '*');
        }
      });
    }

    _waitForSwiper(callback, attempts) {
      attempts = attempts || 0;
      if (window.Swiper) return callback();
      if (attempts >= 30 || !this.isConnected) return;
      var self = this;
      setTimeout(function () {
        self._waitForSwiper(callback, attempts + 1);
      }, 100);
    }

    initSlider() {
      if (!window.Swiper || this.dataset.qvSwiperInit === 'true' || !this.isConnected) return;
      var el = this.querySelector('[data-quick-view-swiper]');
      if (!el) return;
      this.dataset.qvSwiperInit = 'true';

      var self = this;
      var config = {
        slidesPerView: 1.5,
        spaceBetween: 8,
        watchOverflow: true,
        /* ModelViewerUI.play() focuses the model-viewer; Swiper's scrollOnFocus
           would then slideTo() back to the 3D slide on every navigation. */
        a11y: { scrollOnFocus: false },
        on: {
          afterInit: function () {
            self.updateCounter();
          },
          slideChange: function () {
            self.updateCounter();
          },
         
          slideChangeTransitionStart: function () {
            self.pauseAllExcept(null);
          },
        },
      };

      var prevEl = this.querySelector('[data-gallery-prev]');
      var nextEl = this.querySelector('[data-gallery-next]');
      if (prevEl && nextEl) {
        config.navigation = { prevEl: prevEl, nextEl: nextEl };
      }

      this.swiperInstance = new Swiper(el, config);
    }

    updateCounter() {
      var counter = this.querySelector('[data-quick-view-counter]');
      if (!counter || !this.swiperInstance) return;
      var total = this.swiperInstance.slides.length;
      counter.textContent = this.swiperInstance.activeIndex + 1 + ' / ' + total;
    }
  }

  if (!customElements.get('quick-view-media')) {
    customElements.define('quick-view-media', QuickViewMedia);
  }
})();
